export interface ModalResult {
    selectedColumns: ReportColumn[];
}

export enum ReportColumn {
    StartDate = 'STARTED',
    EndDate = 'ENDED',
    Duration = 'DURATION',
    AgentName = 'AGENT',
    AssistantName = 'ASSISTANT',
    GuestNames = 'GUEST',
    ClientId = 'CLIENT_ID',
    ClientName = 'CLIENT_NAME',
    ClientLeftAt = 'CLIENT_LEFT_AT',
    ClientOs = 'CLIENT_OS',
    ClientOsVersion = 'CLIENT_OS_VERSION',
    ClientBrowser = 'CLIENT_BROWSER',
    ClientBrowserVersion = 'CLIENT_BROWSER_VERSION',
    Group = 'GROUP',
    SubGroup = 'SUBGROUP',
    FileName = 'FILENAME',
    Activity = 'ACTIVITY',
    ResultInformation = 'RESULT_INFORMATION',
    Result = 'RESULT',
    FileStatus = 'FILE_STATUS'
}